import { render, staticRenderFns } from "./my_qa_list.vue?vue&type=template&id=a6767352&scoped=true"
import script from "./my_qa_list.vue?vue&type=script&lang=js"
export * from "./my_qa_list.vue?vue&type=script&lang=js"
import style0 from "./my_qa_list.vue?vue&type=style&index=0&id=a6767352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6767352",
  null
  
)

export default component.exports